var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCycleBrand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cycle_brand",
    "data-name": "Cycle brand",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun-cycling-7847926",
    transform: "translate(4.424 -9.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M14.909,53.259a.236.236,0,0,0-.236-.236,1.941,1.941,0,0,0-1.939,1.939.236.236,0,1,0,.471,0,1.471,1.471,0,0,1,1.469-1.469.234.234,0,0,0,.235-.235Z",
    transform: "translate(-8.138 -24.374)",
    fill: "#00b26b",
    stroke: "#00b26b",
    strokeLinejoin: "bevel",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M19.64,26.227l-1.7-4.013V21.028h1.969a.5.5,0,0,1,0,1H18.93a.236.236,0,1,0,0,.471h.979a.97.97,0,0,0,0-1.939h-2.2a.236.236,0,0,0-.236.236,9.1,9.1,0,0,0,.018,1.562l1,2.368H12.577l-.807-1.244H12.9a.236.236,0,0,0,.236-.236v-.47a.991.991,0,0,0-.989-.989H9.82A.823.823,0,0,0,9,22.607v.049a.823.823,0,0,0,.823.823h.152l.948,1.462-1.6,1.932A4.642,4.642,0,1,0,4.5,34.764H3.545a.236.236,0,0,0,0,.471H6.537a4.649,4.649,0,0,0,4.638-4.408H12.2a1.461,1.461,0,0,0,1.951,1.132l.176.308-.363.363a.235.235,0,1,0,.332.332l.49-.49a.236.236,0,0,0,.038-.283l-.266-.464a1.457,1.457,0,0,0,.183-2.089l4.01-4.3.456,1.076a4.643,4.643,0,0,0-.01,8.352h-2.02a.236.236,0,1,0,0,.471h4.056a4.644,4.644,0,1,0-1.592-9.007ZM9.466,22.655v-.049a.352.352,0,0,1,.352-.352H12.15a.519.519,0,0,1,.519.519v.236H9.819a.353.353,0,0,1-.352-.353Zm1.743.824.807,1.244h-.679c-.1-.151-.315-.485-.807-1.244ZM11.148,25.4c.2.46,1.572,3.572,1.736,3.942a1.464,1.464,0,0,0-.684,1.013H11.175a4.638,4.638,0,0,0-1.5-3.183Zm2.172,3.766-1.039-2.36h4.455l-2.357,2.526a1.445,1.445,0,0,0-1.059-.166ZM9.947,30.355a3.41,3.41,0,0,0-1.053-2.238l.483-.582a4.164,4.164,0,0,1,1.327,2.82Zm-3.41.47H9.475a2.948,2.948,0,1,1-1.243-2.647L6.356,30.439a.236.236,0,0,0,.181.386Zm.5-.47L8.593,28.48a2.942,2.942,0,0,1,.882,1.875Zm-.5,4.408a4.173,4.173,0,1,1,2.478-7.529l-.483.582a3.418,3.418,0,1,0,1.415,3.009H10.7a4.177,4.177,0,0,1-4.166,3.938Zm7.782-3.457-.476-.833a.235.235,0,1,0-.408.233l.476.833a.989.989,0,1,1,.408-.233Zm2.855-4.97h-5.1l-.5-1.144h6.672Zm4.057,8.427a4.173,4.173,0,0,1-1.842-7.918l.295.7a3.414,3.414,0,1,0,.432-.184l-.295-.7a4.174,4.174,0,1,1,1.41,8.1Zm.217-4.265L20.3,27.792a2.955,2.955,0,1,1-.433.184l1.146,2.705a.235.235,0,0,0,.433-.183Z",
    transform: "translate(0)",
    fill: "#00b26b",
    stroke: "#00b26b",
    strokeLinejoin: "bevel",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M81.279,53.987a1.465,1.465,0,0,1,.912,1.36.236.236,0,1,0,.471,0,1.933,1.933,0,0,0-1.2-1.8.235.235,0,0,0-.179.435Z",
    transform: "translate(-59.49 -24.757)",
    fill: "#00b26b",
    stroke: "#00b26b",
    strokeLinejoin: "bevel",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M58.015,77.555h-.236a.236.236,0,0,0,0,.471h.236a.236.236,0,1,0,0-.471Z",
    transform: "translate(-41.779 -42.792)",
    fill: "#00b26b",
    stroke: "#00b26b",
    strokeLinejoin: "bevel",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycleBrand);
export default __webpack_public_path__ + "static/media/CycleBrand.07d0ee2033df2596ff18e6bdc8e0bcfd.svg";
export { ForwardRef as ReactComponent };